import { useModuleContext } from '@cognitranlimited/itis-web';
export var termsModuleId = Symbol('termsModule');
export var useTermsModuleContext = function () { return useModuleContext(termsModuleId); };
